<template lang="pug">
v-container(style="max-width:960px")
  v-row(align="center" v-if="!isMobileScreen")
    v-col(cols="12")
      .d-flex.align-center.justify-end
        yc-pagination-custom.ml-4.my-auto(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('item_list')" @input="pageChanged")
        slot(name="actions")

  .yc-table
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="campaigns" item-key="id" :items-per-page="pageSize" :loading="isLoading" hide-default-footer disable-sort)
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(#item.index="{ item }")
        div {{ item.index + 1 }}
      template(#item.title="{ item }")
        div.p1.info500--text.clickable(@click="clickItem(item)") {{ item.title }}
      template(#item.donated_amount="{ item }")
        div {{ item.donated_amount | displayPrice }}
      template(#item.donor_count="{ item }")
        div {{ item.donor_count }}
      template( #item.percentage="{ item }")
        div {{ item.percentage }}%

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'CampaignsRanking',
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
  },
  components: {},
  data: () => ({
    currentPage: 1,
    isLoading: false,
    searchText: '',
    pageSize: 20,
    totalCount: 0,
    sortBy: '-form__total_sales',
    campaigns: [],
    headers: [
      {
        text: 'Ranking',
        value: 'index',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Campaign',
        value: 'title',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Total Raised',
        value: 'donated_amount',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Donor',
        value: 'donor_count',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Donation Progress',
        value: 'percentage',
        enable: true,
        class: 'text-table-header'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchCampaigns(1)
    },
  },
  mounted () {
    this.fetchCampaigns(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    getCampaigns(page, pageSize, sortBy) {
      const params = {
        page_size: pageSize,
        page,
        ordering: sortBy
      }
      return this.$axios.get(`/donations/${this.company.slug}/campaigns`, { params })
    },
    fetchCampaigns(page) {
      this.isLoading = true
      this.getCampaigns(page, this.pageSize, this.sortBy)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.campaigns = resp.data.results
            this.campaigns.map((c, idx) => {
              c.index = idx + (page - 1) * this.pageSize
              if (c.goal_amount) {
                c.percentage = parseInt(c.donated_amount / c.goal_amount * 100)
              } 
            })
          }
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    pageChanged(num) {
      this.fetchCampaigns(num)
    },
    clickItem (item) {
      this.$router.push(`/admin/donation/campaign/${item.slug}`)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.clickable {
  cursor: pointer;
}
</style>